import { createColumnHelper } from "@tanstack/react-table";
import { formatToMMDD } from "features/freights/utils/utils";

const columnHelper = createColumnHelper<any>();

export const getETA = (handleRedirect: (s: any, d?: any, e?: any) => void, typeOfFreight: string) => [
  columnHelper.accessor("latestEta", {
    id: "latestEta",
    header: "ETA Date",
    cell: (props) => formatToMMDD(props.getValue()),
    size: 80,
  }),

  columnHelper.accessor(
    (row) => row.numberOfShipments ?? row.pros, {
    id: "numberOfShipments",
    header: "Shipments",
    cell: (props) => {
      return <div style={{ color: '#2F80ED', cursor: 'pointer' }} onClick={() => {
        handleRedirect(typeOfFreight, '', props.row.original.latestEta);
      }}>{props.getValue() ?? '-'}</div>
    },
    size: 90,
  }),

  columnHelper.accessor(
    (row) => row.numberOfPieces ?? row.pieces,
    {
      id: "numberOfPieces",
      header: "Pieces",
      cell: (info) => info.getValue() ?? "-",
      size: 70,
    }
  ),

  columnHelper.accessor("weight", {
    id: "weight",
    header: "Weight (lbs)",
    cell: (props) => {
      const value = props.getValue();
      return value ? value?.toLocaleString() : '-';
    },
    size: 100,
  }),

  columnHelper.accessor("numberOfTrailers", {
    id: "numberOfTrailers",
    header: "Trailers",
    cell: (props) => props.getValue() ?? '-',
    size: 90,
  }),
];
